/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import IntegrationsMparticleModel from 'cio/models/integrations/mparticle';
import AnalyticsService from 'cio/services/analytics';
import { Task } from 'ember-concurrency';

interface IntegrationsMparticleConnectFormArgs {
  key: string;
  isConnected: boolean;
  isReadOnly: boolean;
  connectIntegrationTask: Task<IntegrationsMparticleModel, [string, string]>;
  disconnectIntegrationTask: Task<IntegrationsMparticleModel, []>;
}

const MPARTICLE_META = {
  name: 'mParticle',
  category: 'Data management',
  subCategory: 'Source',
};

export default class IntegrationsMparticleConnectForm extends Component<IntegrationsMparticleConnectFormArgs> {
  @service analytics!: AnalyticsService;

  @tracked key = '';
  @tracked secret = '';

  get isValid() {
    return !isEmpty(this.key?.trim()) && !isEmpty(this.secret?.trim());
  }

  @action
  setupKeys() {
    this.key = this.args.key ?? '';
    this.secret = this.args.key ? '••••••••' : '';
  }

  @action
  connectIntegration(event: KeyboardEvent | MouseEvent) {
    event.preventDefault();
    this.analytics.track('integration', 'enable_started', MPARTICLE_META);
    this.args.connectIntegrationTask.perform(this.key, this.secret);
  }

  @action
  disconnectIntegration() {
    this.analytics.track('integration', 'disable_started', MPARTICLE_META);
    this.args.disconnectIntegrationTask.perform();
  }
}
